// File: frontend/src/components/SettingsPage.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GeneralTab from './settings/GeneralTab';
import DataModelTab from './settings/DataModelTab';
import ImportExportTab from './settings/ImportExportTab';
import ProfileTab from './settings/ProfileTab';
import AuditLogs from './AuditLogs';

const SettingsPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('general');

  const tabs = [
    // La pestaña "Apariencia" se eliminó: la identidad visual es la marca fija de Pandemonium,
    // no configurable por el usuario (sin switch light/dark, sin acento).
    { id: 'general',        label: t('settings.tabs.general') },
    { id: 'profile',        label: t('settings.tabs.profile') },
    { id: 'data-model',     label: t('settings.tabs.dataModel') },
    { id: 'import-export',  label: t('settings.tabs.importExport') },
    // Registro de auditoría: visible para TODOS los usuarios con acceso. Vassago es un espacio
    // compartido de consulta, así que cualquiera puede ver el rastro de actividad de los demás.
    { id: 'audit-logs',     label: t('settings.tabs.auditLogs') },
    // La pestaña "users" desapareció: el alta, baja y rol de usuarios vive solo en el hub
    // de Pandemonium (ONBOARDING-nueva-app.md §1). Aquí no hay nada que gestionar.
  ];

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-6">{t('settings.pageTitle')}</h1>

      <div className="glass-card">
        {/* Tab Navigation */}
        <div className="border-b border-slate-200 dark:border-slate-700">
          <nav className="flex space-x-8 px-6 overflow-x-auto" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors duration-150 ${
                  activeTab === tab.id
                    ? 'border-accent-primary text-accent-primary'
                    : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:border-slate-300 dark:hover:border-slate-600'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {activeTab === 'general'       && <GeneralTab />}
          {activeTab === 'profile'       && <ProfileTab />}
          {activeTab === 'data-model'    && <DataModelTab />}
          {activeTab === 'import-export' && <ImportExportTab />}
          {activeTab === 'audit-logs'    && <AuditLogs />}
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
